import React from 'react'
import { useField } from 'formik'

const style = {
    fontSize:"0.83em",
    fontStyle:"italic",
    color:"red",
    textAlign:"left",
    padding:"0"
}

const FormInputNormal = ({
    step,
    name,
    type,
    placeholder,
    disabled
}) => {
    const [field, meta] = useField(name);

    return (
        <>
            <input 
                {...field}
                step={step}
                type={type}
                value={field.value ? field.value : ''}
                placeholder={placeholder}
                disabled={disabled}
                className="form-control"
            />
            {meta.error && meta.touched && 
            <div style={style}>
                {"*" + meta.error}
            </div>}
        </>
    )
}

export default FormInputNormal;